import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import ComposerState from 'flarum/forum/states/ComposerState';
function insertTemplate(contentOverwrite) {
  var _composerBody$attrs;
  if (contentOverwrite === void 0) {
    contentOverwrite = false;
  }
  if (!app.composer.fields) return;
  const composerFields = app.composer.fields;
  if (!composerFields.tags) return;
  const composerBody = app.composer.body;
  const original = ((_composerBody$attrs = composerBody.attrs) == null ? void 0 : _composerBody$attrs.originalContent) || '';
  const content = app.composer.fields.content().trim();
  if (content !== original && !app.forum.attribute('appendTemplateOnTagChange')) return;
  const templateCandidates = {};
  composerFields.tags.forEach(function (tag) {
    if (tag.position() === null || !tag.template()) return;
    templateCandidates[tag.id()] = tag.template();
  });
  const ids = Object.keys(templateCandidates);
  if (ids.length === 2) {
    const first = app.store.getById('tags', ids[0]);
    const second = app.store.getById('tags', ids[1]);
    if (first && second) {
      if (first.parent() === second) {
        delete templateCandidates[ids[1]];
      }
      if (second.parent() === first) {
        delete templateCandidates[ids[0]];
      }
    }
  }
  if (Object.keys(templateCandidates).length === 1) {
    let template = Object.values(templateCandidates)[0];
    if (content === template) return;
    if (content === original) {
      composerBody.attrs.originalContent = template;
    } else {
      template = '\n\n' + template;
    }
    if (contentOverwrite) {
      app.composer.fields.content(template);
    } else {
      app.composer.editor.insertAtCursor(template, false);
    }
  }
}
export default function configureTagTemplates() {
  extend(IndexSidebar.prototype, 'newDiscussionAction', function (promise) {
    promise.then(composer => {
      var _composer$fields;
      if (((_composer$fields = composer.fields) == null || (_composer$fields = _composer$fields.tags) == null ? void 0 : _composer$fields.length) > 0) {
        insertTemplate();
      } else {
        const noTagTemplate = app.forum.attribute('fof-discussion-templates.no_tag_template');
        if (noTagTemplate && composer.editor) {
          composer.editor.insertAtCursor(noTagTemplate, false);
        }
      }
    }).catch(() => {});
  });
  extend('ext:flarum/tags/forum/components/TagDiscussionModal', 'onremove', function () {
    var _tags;
    if (app.composer.fields && ((_tags = app.composer.fields.tags) == null ? void 0 : _tags.length) > 0) {
      insertTemplate();
    }
  });
  override(ComposerState.prototype, 'show', function (originalFunction) {
    var _this$fields;
    // Check if composing a new discussion using bodyMatches with string path
    if (this.bodyMatches('flarum/forum/components/DiscussionComposer') && ((_this$fields = this.fields) == null ? void 0 : _this$fields.content().trim()) === '') {
      // Only insert template if the composer is empty

      if (this.fields.tags) {
        // Insert if 1+ tags are selected
        insertTemplate(true);
      } else if (Array.isArray(this.fields.tags)) {
        // Insert if no tags are selected, but tags field present
        const noTagTemplate = app.forum.attribute('fof-discussion-templates.no_tag_template');
        if (noTagTemplate && this.fields) {
          this.fields.content(noTagTemplate);
        }
      }
    }
    return originalFunction();
  });
}